import { defineStore } from "pinia";
import { getActiveCarousel } from "@/modules/admin/homepage/api/homepage.service";

let requestPromise = null;

export const usePublicCarouselStore = defineStore("publicCarousel", {
  state: () => ({
    items: [],
    status: "idle",
  }),

  actions: {
    ensureLoaded() {
      if (this.status === "success") {
        return Promise.resolve(this.items);
      }

      if (requestPromise) {
        return requestPromise;
      }

      this.status = "loading";
      requestPromise = getActiveCarousel()
        .then((items) => {
          this.items = items;
          this.status = "success";
          return items;
        })
        .catch((error) => {
          this.status = "error";
          throw error;
        })
        .finally(() => {
          requestPromise = null;
        });

      return requestPromise;
    },
  },
});
